export interface NavSubItem {
  label: string
  label_ml?: string
  slug: string
}

export interface NavChildItem {
  label: string
  label_ml?: string
  slug?: string
  subChildren?: NavSubItem[]
}

export interface NavItem {
  label: string
  label_ml?: string
  slug?: string
  children?: NavChildItem[]
}
// translations.ts
export const navItems: NavItem[] = [
  {
    label: 'Home',
    label_ml: 'ഹോം',
    slug: 'AUTH_HOME',
  },
  {
    label: 'About Us',
    label_ml: 'ഞങ്ങളെക്കുറിച്ച്',

    children: [
      {
        label: 'About KIED',
        label_ml: 'KIED-യെക്കുറിച്ച്',
        slug: 'ABOUT_KIED',
      },
      {
        label: 'Governing Council Members',
        label_ml: 'സംഘടനാ കൗൺസിൽ അംഗങ്ങൾ',
        slug: 'OUR_MEMBERS',
      },
      // { label: 'Our Team', label_ml: 'ഞങ്ങളുടെ ടീം', slug: 'OUR_TEAM' },
      { label: 'Contact Us', label_ml: 'ബന്ധപ്പെടുക', slug: 'CONTACT_US' },
    ],
  },
  {
    label: 'Departments',
    label_ml: 'വിഭാഗങ്ങൾ',

    children: [
      { label: 'Learning', label_ml: 'പഠനം', slug: 'LEARNING' },
      // { label: 'Incubation', label_ml: 'ഇൻക്യൂബേഷൻ', slug: 'INCUBATION' },
      { label: 'Facilitation', label_ml: 'സഹായം', slug: 'FACILITATION' },
      {
        label: 'Technology Transfer',
        label_ml: 'സാങ്കേതിക കൈമാറ്റം',
        slug: 'TECHNOLOGY_TRANSFER',
      },
      {
        label: 'Industry Academy Collaboration',
        label_ml: 'ഇൻഡസ്ട്രി അക്കാദമി സഹകരണം',
        slug: 'INDUSTRY_ACADEMY_COLLABORATION',
      },
    ],
  },
  {
    label: 'Initiatives',
    label_ml: 'ഉദ്ദേശ്യങ്ങൾ',

    children: [
      {
        label: 'Training',
        label_ml: 'പരിശീലനം',
        subChildren: [
          {
            label: 'Training Calendar',
            label_ml: 'പരിശീലന കലണ്ടർ',
            slug: 'TRAININGCALENDAR',
          },
        ],
      },
      {
        label: 'NBFC',
        label_ml: 'എൻ.ബി.എഫ്.സി',
        slug: 'NBFC',
      },
      {
        label: 'EDC',
        label_ml: 'ഇ.ഡി.സി',
        slug: 'EDC',
      },
      {
        label: 'Upcoming Events',
        label_ml: 'അടുത്ത സംഭവങ്ങൾ',
        slug: 'UPCOMMINGEVENTS',
      },
    ],
  },
  {
    label: 'Resources',
    label_ml: 'സ്രോതസ്സ്',

    children: [
      {
        label: 'Study Materials',
        label_ml: 'അധ്യയന സാമഗ്രികൾ',
        subChildren: [
          { label: 'Materials', label_ml: 'സാമഗ്രികൾ', slug: 'MATERIALS' },
          { label: 'Schemes', label_ml: 'യോജനകൾ', slug: 'SCHEMES' },
        ],
      },
      {
        label: 'Publications & Newsletters',
        label_ml: 'പ്രസിദ്ധീകരണങ്ങൾ & ന്യൂസ് ലെറ്ററുകൾ',
        slug: 'PUBLICATIONS_AND_NEWSLETTERS',
      },
      {
        label: 'Annual Report',
        label_ml: 'വാർഷിക റിപ്പോർട്ട്',
        slug: 'ANNUALREPORTS',
      },
      {
        label: 'Photos',
        label_ml: 'ഫോട്ടോകൾ',
        slug: 'GALLERY_PHOTO',
      },
      {
        label: 'Videos',
        label_ml: 'വീഡിയോകൾ',
        slug: 'GALLERY_VIDEO',
      },
    ],
  },
  {
    label: 'Information',
    label_ml: 'വിവരങ്ങൾ',

    children: [
      { label: 'RTI', label_ml: 'ആർടിഐ', slug: 'RTI' },
      {
        label: 'Acts,Rules and Government Orders(GO)',
        label_ml: 'നിയമങ്ങൾ, ചട്ടങ്ങൾ & സർക്കാർ ഉത്തരവ്',
        slug: 'ACTS_RULES_GOVERNMENT_ORDERS',
      },
      {
        label: 'Grievance Redressal',
        label_ml: 'പക്ഷപാതപരമായ പരാതികൾ',
        slug: 'REDRESSAL',
      },
      { label: 'Tenders', label_ml: 'ടെണ്ടറുകൾ', slug: 'TENDERS' },
      { label: 'Careers', label_ml: 'കരിയർ', slug: 'CAREERS' },
      { label: 'Internships', label_ml: 'ഇന്റേൺഷിപ്സ്', slug: 'INTERNSHIPS' },
    ],
  },
]
